import { useClerk } from '@clerk/clerk-react';
import { Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { toast } from '@/hooks/ui/use-toast';

const ConfirmEmail = () => {
  const navigate = useNavigate();
  const { handleEmailLinkVerification } = useClerk();

  useEffect(() => {
    const verifyEmail = async (): Promise<void> => {
      try {
        await handleEmailLinkVerification({
          redirectUrl: `${window.location.origin}/${window.localStorage.getItem('active-org-id')}/auth/join-org`,
          redirectUrlComplete: `${window.location.origin}/${window.localStorage.getItem('active-org-id')}/auth/join-org`,
        });
      } catch (err) {
        if (err instanceof Error && 'code' in err && err.code === 'expired') {
          toast({
            variant: 'destructive',
            title: 'Email link has been expired',
            description: 'Please try again',
          });
        } else {
          toast({
            variant: 'destructive',
            title: 'Email link verification failed',
            description: 'Please try again',
          });
        }
        navigate(
          `/${window.localStorage.getItem('active-org-id')}/auth/sign-up`
        );
      }
    };

    void verifyEmail();
  }, [navigate, handleEmailLinkVerification]);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="text-center">
        <div className="mb-4 flex items-center justify-center">
          <Loader2 className="size-4 animate-spin" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900">
          Confirming Email
        </h2>
        <p className="mt-2 text-sm text-gray-600">
          Please wait while we verify your email address...
        </p>
      </div>
    </div>
  );
};

export { ConfirmEmail };
